import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

import { Media } from "@/components/forms/schemas/media";
import { artistSpotifyEnrichmentSchema } from "@/pages/artists/schemas/artist.spotifyenrichment.form";

// Step 1
export const basicArtistSchema = z.object({
  spotifyId: z
    .string()
    .nullish()
    .superRefine(
      fieldConfig({
        description: "Spotify Artist ID. Fetched from Spotify API.",
        label: "Spotify ID",
        inputProps: {
          disabled: true,
        },
      }),
    ),
  name: z.string().superRefine(
    fieldConfig({
      description: "Artist display name. This will be publicly visible.",
    }),
  ),
});

// Step 2
export const spotifyArtistStepSchema = z.object({
  spotifyEnrichment: artistSpotifyEnrichmentSchema.nullish(),
});

// Step 3
export const mediaArtistSchema = z.object({
  id: z.string().superRefine(fieldConfig({ inputProps: { disabled: true } })),
  hide: z.boolean().default(false),
  media: Media.superRefine(
    fieldConfig({
      fieldType: "media",
      customData: {
        collection: "Artists",
      },
    }),
  ),
});

export const artistAIStepSchema = z.object({
  instagramScreenshot: z.string().nullish(),
});

export const createArtistFormSchema = z
  .object({ id: z.string() })
  .merge(basicArtistSchema)
  .merge(spotifyArtistStepSchema)
  .merge(artistAIStepSchema)
  .merge(mediaArtistSchema);

export type ArtistBasicType = z.infer<typeof basicArtistSchema>;
export type ArtistSpotifyEnrichmentType = z.infer<
  typeof artistSpotifyEnrichmentSchema
>;
export type ArtistMediaType = z.infer<typeof mediaArtistSchema>;
export type ArtistAIEnrichmentStepType = z.infer<typeof artistAIStepSchema>;

export type CreateArtistFormType = z.infer<typeof createArtistFormSchema>;
